import React from "react";
import { NavLink } from "react-router-dom";
import {
    AppBar,
    Box,
    IconButton,
    Stack,
    Toolbar,
    Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FaGithub, FaMoon } from "react-icons/fa6";
import { IoIosSunny } from "react-icons/io";

import logoBlack from "../../assets/logo_black.png";
import logoWhite from "../../assets/logo_white.png";

function NavBar({ themeMode, onToggleTheme }) {
    const iconButtonSx = (theme) => ({
        width: 42,
        height: 42,
        borderRadius: 2.5,
        border: `1px solid ${alpha(theme.palette.text.primary, theme.palette.mode === "dark" ? 0.18 : 0.12)}`,
        background:
            theme.palette.mode === "dark"
                ? "linear-gradient(135deg, rgba(28,32,38,0.9), rgba(20,23,28,0.6))"
                : "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.65))",
        color: theme.palette.text.primary,
        boxShadow:
            theme.palette.mode === "dark"
                ? "0 16px 28px rgba(0,0,0,0.45)"
                : "0 14px 30px rgba(0,0,0,0.12)",
        transition:
            "transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
        "&:hover": {
            transform: "translateY(-2px)",
            boxShadow:
                theme.palette.mode === "dark"
                    ? "0 20px 36px rgba(0,0,0,0.6)"
                    : "0 18px 36px rgba(0,0,0,0.18)",
            background:
                theme.palette.mode === "dark"
                    ? "linear-gradient(135deg, rgba(40,45,54,0.98), rgba(24,27,34,0.7))"
                    : "linear-gradient(135deg, rgba(255,255,255,1), rgba(255,255,255,0.8))",
        },
    });

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                background:
                    themeMode === "dark"
                        ? "linear-gradient(120deg, rgba(14,16,20,0.8), rgba(14,16,20,0.55))"
                        : "linear-gradient(120deg, rgba(255,255,255,0.75), rgba(255,255,255,0.4))",
                borderBottom: "1px solid",
                borderColor: "divider",
                backdropFilter: "blur(16px)",
            }}>
            <Toolbar
                sx={{
                    minHeight: { xs: 72, md: 78 },
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 2,
                    py: 1,
                }}>
                <Stack
                    component={NavLink}
                    to="/"
                    direction="row"
                    alignItems="center"
                    spacing={1.8}
                    sx={{ textDecoration: "none", color: "inherit" }}>
                    <Box
                        sx={{
                            width: 52,
                            height: 52,
                            borderRadius: 3,
                            display: "grid",
                            placeItems: "center",
                            background:
                                themeMode === "dark"
                                    ? "linear-gradient(135deg, rgba(40,45,54,0.9), rgba(24,27,34,0.7))"
                                    : "linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.7))",
                            border: "1px solid",
                            borderColor: "divider",
                            boxShadow: "0 18px 40px rgba(0,0,0,0.2)",
                            overflow: "hidden",
                        }}>
                        <Box
                            component="img"
                            src={themeMode === "dark" ? logoWhite : logoBlack}
                            alt="QR & Barcode Toolkit"
                            sx={{
                                width: 34,
                                height: 34,
                                objectFit: "contain",
                                filter:
                                    themeMode === "dark"
                                        ? "drop-shadow(0 6px 14px rgba(0,0,0,0.4))"
                                        : "none",
                            }}
                        />
                    </Box>
                    <Typography
                        variant="h6"
                        sx={{ fontWeight: 700, letterSpacing: "-0.02em" }}>
                        QR &amp; Barcode Toolkit
                    </Typography>
                </Stack>
                <Stack direction="row" spacing={1.5} alignItems="center">
                    <IconButton
                        component="a"
                        href="https://github.com/bilalabdulhadii/react-qr-barcode-toolkit"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="GitHub"
                        sx={iconButtonSx}>
                        <FaGithub size={20} />
                    </IconButton>
                    <IconButton
                        onClick={onToggleTheme}
                        aria-label="Toggle theme"
                        sx={iconButtonSx}>
                        {themeMode === "dark" ? (
                            <IoIosSunny size={18} />
                        ) : (
                            <FaMoon size={18} />
                        )}
                    </IconButton>
                </Stack>
            </Toolbar>
        </AppBar>
    );
}

export default NavBar;
